import compose from 'ramda/src/compose.js';
import isNil from 'ramda/src/isNil.js';
import isEmpty from 'ramda/src/isEmpty.js';
import either from 'ramda/src/either.js';
import not from 'ramda/src/not.js';
import any from 'ramda/src/any.js';
import all from 'ramda/src/all.js';

const isEmptyOrNil = either(isNil, isEmpty);
const notEmptyOrNil = compose(not, isEmptyOrNil);
const anyNotEmptyOrNil = any(notEmptyOrNil);
const anyEmptyOrNil = any(isEmptyOrNil);
const allEmptyOrNil = all(isEmptyOrNil);

var EmptyOrNil = /*#__PURE__*/Object.freeze({
	__proto__: null,
	isEmptyOrNil: isEmptyOrNil,
	notEmptyOrNil: notEmptyOrNil,
	anyNotEmptyOrNil: anyNotEmptyOrNil,
	anyEmptyOrNil: anyEmptyOrNil,
	allEmptyOrNil: allEmptyOrNil
});

export { EmptyOrNil as E, anyNotEmptyOrNil as a, anyEmptyOrNil as b, allEmptyOrNil as c, isEmptyOrNil as i, notEmptyOrNil as n };
//# sourceMappingURL=EmptyOrNil-f73f04c0.js.map
